import React from 'react';
import PropTypes from 'prop-types';
import {
    PreviousSearchesListItem,
    SearchesSuggestionsListItem,
    ShopsSuggestionsListItem,
    AdvancedSearchListItem,
    SellerSearchListItem
} from './suggestion-list-items';

const SearchSuggestion = ({
    suggestions,
    inSPA,
    visible,
    onChangeSearchTerm,
    searchTerm,
    selectedCategoryId,
    selectedIndex,
    searchSuggestionsElementRef
}) => (
    <section
        data-search-suggestions-container
        className={`slim-header__search-suggestions rounded ${
            visible ? 'visible' : ''
        }`}
        ref={searchSuggestionsElementRef}>
        <div className="list-group">
            {suggestions.map((entry, index) => {
                const componentProps = {
                    key: entry.key,
                    changeSearchTerm: onChangeSearchTerm,
                    inSPA: inSPA,
                    item: entry.item,
                    text: entry.text,
                    isSelected: index === selectedIndex,
                    searchTerm: searchTerm,
                    selectedCategoryId: selectedCategoryId
                };
                switch (entry.type) {
                    case 'previous':
                        return (
                            <PreviousSearchesListItem
                                key={entry.key}
                                {...componentProps}
                            />
                        );
                    case 'suggested-item':
                        return (
                            <SearchesSuggestionsListItem
                                key={entry.key}
                                {...componentProps}
                            />
                        );
                    case 'suggested-shop':
                        return (
                            <ShopsSuggestionsListItem
                                key={entry.key}
                                {...componentProps}
                            />
                        );
                    case 'link-advanced-search':
                        return (
                            <AdvancedSearchListItem
                                key={entry.key}
                                {...componentProps}
                            />
                        );
                    case 'link-seller-search':
                        return (
                            <SellerSearchListItem
                                key={entry.key}
                                {...componentProps}
                            />
                        );
                    default:
                        throw new Error(
                            'unhandled entry type: ',
                            JSON.stringify(entry)
                        );
                }
            })}
        </div>
    </section>
);

SearchSuggestion.propTypes = {
    allSuggestions: PropTypes.array,
    isSearchInputFocused: PropTypes.bool,
    onChangeSearchTerm: PropTypes.func,
    previousSearches: PropTypes.array,
    searchTerm: PropTypes.string,
    selectedCategoryId: PropTypes.number,
    selectedIndex: PropTypes.number,
    setSearchSuggestionsElement: PropTypes.func
};

export default SearchSuggestion;
